import {
  Stack
} from "@chakra-ui/react";
import React, { memo, useCallback, useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import useExperiments from "../../../hooks/quests/useExperiments";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { useUpdateNodeHandles } from "../../../hooks/useUpdateNodeHandles";
import { NodeData, NodeType, SourceHandle } from "../../../models/nodeType";
import SelectExperiment from "../../base/SelectExperiment";
import { FlowNodeWithChildren } from "./FlowNode";

interface ConditionExperiment extends NodeData {
  experimentId: string;
}

const ConditionExperimentNode: React.FC<NodeProps<NodeType>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData, sourceHandles = [] },
  } = props;

  const experimentId = nodeData?.experimentId ?? "";

  const { updateNodeSourceHandles } = useUpdateNodeHandles(nodeId);
  const { experiments = [] } = useExperiments();

  const { getValues, setValue, handleSubmit } = useForm<ConditionExperiment>({
    defaultValues: useMemo(
      () => ({experimentId}),
      [experimentId]
    ),
    mode: "onBlur",
  });

  const { updateNodeData } = useUpdateNodeData<ConditionExperiment>(nodeId);

  const handleUpdate = useCallback(
    ({ experimentId }: ConditionExperiment) => {
      updateNodeData({experimentId});

      if (!experimentId) {
        updateNodeSourceHandles([]);
      }
      else {
        const experiment = experiments.find((experiment)=>experiment.experimentId == experimentId)
        if (experiment) {
          const newSourceHandles: SourceHandle[] = experiment.variants.map((variant, idx) => ({
            handleId: sourceHandles[idx]?.handleId,
            label: variant.variantName,
            handleName: variant.variantName,
            handleType: "source",
            handleCategory: "flow",
          }));
          updateNodeSourceHandles(newSourceHandles)
        }
      }
    },
    [updateNodeData, setValue, experiments, sourceHandles]
  );

  return (
    <FlowNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
        <Stack>
          <SelectExperiment color={color} value={getValues("experimentId")} setValue={(value) => setValue("experimentId", value)} />
        </Stack>
      </form>
    </FlowNodeWithChildren>
  );
};

export default memo(ConditionExperimentNode);
